import { FreeDataValueWrapper, FreeDataValueCriteria, FreeDataValueScenario } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { FreedataDataload } from '../../../vo/core/freedata.dataload';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';

/**
 * Appels FDV sur NumRev
 * Author LMA
 */
export class FreeDataValueCmd extends WizCommand<FreeDataValueWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  
  public dataLoad: FreedataDataload; // le pool de chargement
  public method: string = null; // méthode appelée, pour traitement correct au result


  /** retourne un wrapper pre-alimenté */
  public freedataValueWrapper(): FreeDataValueWrapper {
    const wrapper: FreeDataValueWrapper = new FreeDataValueWrapper();
    wrapper.criteria = new FreeDataValueCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.scenario = new FreeDataValueScenario();
    wrapper.scenario.languageCode = this.model.localeEngine.getLocale();
    return wrapper;
  }

  /** 
   * collecte des FD modifiés / créés sur base NumRev
   * 
   * @param dataload le pool de chargement
   * @param freedataCode cible, pour refresh avant commit
   * @param callback de retour
   * @returns la commande préparée
   */
   public findFromRevNumber(dataload: FreedataDataload, freedataCode?: string, callback?: Function): FreeDataValueCmd {
    this.dataLoad = dataload;
    this.method  = WIZ_COMMAND_METHOD.FIND; // pour gestion du result
    
    const wrapper: FreeDataValueWrapper = this.freedataValueWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.criteria.revisionNumber = dataload.revisionNumber;
    
    if(freedataCode) { // recherche ciblée pour 1 Freedata
      wrapper.criteria.freeDataCode = freedataCode;
    }
    this.configureRemote(ExternalAPI.FREEDATA_VALUE_API, wrapper, callback);

    return this;
  }


  /** sur retour, traitement selon la méthode */
  public wizResult() {
    super.wizResult();
    if (this.result) {
      switch(this.method) {
        case WIZ_COMMAND_METHOD.FIND:
          this.dataLoad.freedataValues = this.result.entities;
        break;
      }
    } else {
      console.log('freedataValueCmd no result');
    }
  }
}
